import { render, staticRenderFns } from "./common-upload-file.vue?vue&type=template&id=8be564ea&scoped=true&"
import script from "./common-upload-file.ts?vue&type=script&lang=ts&"
export * from "./common-upload-file.ts?vue&type=script&lang=ts&"
import style0 from "./common-upload-file.scss?vue&type=style&index=0&id=8be564ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be564ea",
  null
  
)

export default component.exports